import { ButtonPreset } from '@/constants/componentPresets';

const ICON_ONLY_PADDING = 10;
const DEFAULT_BUTTON_PADDING = '10px 18px';
const TAB_BUTTON_PADDING = '6px 19px';
const BUTTON_PADDING_BY_PRESET: Partial<Record<ButtonPreset, string | number>> = {
  [ButtonPreset.TabActive]: TAB_BUTTON_PADDING,
  [ButtonPreset.TabInactive]: TAB_BUTTON_PADDING,
};

interface ResolveButtonPaddingInput {
  padding?: string | number;
  preset: ButtonPreset;
  hasIcon: boolean;
  hasLabel: boolean;
  hasChildren: boolean;
}

interface ResolveIsIconOnlyInput {
  hasIcon: boolean;
  hasLabel: boolean;
  hasChildren: boolean;
}

interface ResolveIconOnlySizeInput {
  isIconOnly: boolean;
  iconSize: number;
  padding: string | number;
  borderWidth: number;
}

export function resolveButtonPadding({
  padding,
  preset,
  hasIcon,
  hasLabel,
  hasChildren,
}: ResolveButtonPaddingInput): string | number {
  if (padding != null) {
    return padding;
  }

  if (hasIcon && !hasLabel && !hasChildren) {
    return ICON_ONLY_PADDING;
  }

  return BUTTON_PADDING_BY_PRESET[preset] ?? DEFAULT_BUTTON_PADDING;
}

export function resolveIsIconOnly({
  hasIcon,
  hasLabel,
  hasChildren,
}: ResolveIsIconOnlyInput): boolean {
  return hasIcon && !hasLabel && !hasChildren;
}

export function resolveIconOnlySize({
  isIconOnly,
  iconSize,
  padding,
  borderWidth,
}: ResolveIconOnlySizeInput): number | undefined {
  if (!isIconOnly) {
    return undefined;
  }

  const actualPadding = typeof padding === 'number' ? padding : ICON_ONLY_PADDING;
  return iconSize + actualPadding * 2 + borderWidth * 2;
}
